export default "__VITE_ASSET__DpQ$FSDh__"